import { Directive, Input } from '@angular/core';
import { TemplateRef, ViewContainerRef } from '@angular/core';
import { AccessControlService, ResourcePermission, GetResourcePermissionsByKey } from '../access-control';
import { ValidateResourcePermissionInput } from '../security.helper';

@Directive({ selector: '[mcIfHasAccess]' })
export class PermissionGuardDirective {
    constructor(
        private accessControl: AccessControlService,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
    ) { }

    @Input() set mcIfHasAccess(input: ResourcePermission | string) {
        let rp: ResourcePermission;
        if (typeof input === 'string') {
            rp = GetResourcePermissionsByKey(input);
        } else {
            rp = input;
        }

        ValidateResourcePermissionInput(rp, 'PermissionGuardDirective');

        const hasAccess = this.accessControl.HasUserAccess(rp);

        if (hasAccess) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/guards/permission-guard.directive.ts